 export const UNLICENSED_AGENT_CODE = 'SFG0083625'
 export const TEAM_LEADER_AGENT_CODE = 'SFG0037732'
 export const SFG_DIRECT_AGENT_CODE = 'SFG0008482'

 export const DISABLED_PAGES_IN_DEMO_MODE = [
    '/page/agent-bio',
    '/page/key-leader-academy',
    '/page/master-commission-schedule',
    '/page/agency-owner-academy',
]

const zendeskFieldsOptions = [
	{ fieldId: 37445112626715, agentKey: 'AgentCode', defaultValue: '' },
	{ fieldId: 34662826684315, agentKey: 'AgentEmail', defaultValue: '' },
	{ fieldId: 34662830922395, agentKey: 'AgentName', defaultValue: '' },
	{ fieldId: 37445099409691, agentKey: 'FirstName', defaultValue: '' },
	{ fieldId: 37445117516443, agentKey: 'LastName', defaultValue: '' },
	{ fieldId: 37462756705563, agentKey: 'IsAgencyOwner', defaultValue: false },
	{ fieldId: 37462747739931, agentKey: 'IsSFGDirect', defaultValue: false },
	{ fieldId: 37445164259739, agentKey: 'State', defaultValue: '' },
	{ fieldId: 37445187116443, agentKey: 'Status', defaultValue: '' },
	{ fieldId: 37445188621979, agentKey: 'UplineAgentName', defaultValue: '' },
	{ fieldId: 36669452794523, agentKey: 'ContractLevel', defaultValue: '' },
	{ fieldId: 37445183735707, agentKey: 'BaseshopOwnerAgentName', defaultValue: '' },
	{ fieldId: 37445214917147, agentKey: 'NPN', defaultValue: '' },
]

const getValue = (rawValue, defaultValue) => {
	if (typeof defaultValue === 'string') {
		return String(rawValue) || defaultValue
	} else if (typeof defaultValue === 'boolean') {
		return Boolean(rawValue) || defaultValue
	} else {
		return rawValue || defaultValue
	}
}

export const getZendeskFields = (agent) => zendeskFieldsOptions.map(
	({ fieldId, agentKey, defaultValue }) => ({
		id: String(fieldId),
		value: getValue(agent[agentKey], defaultValue),
	})
)
